import React from 'react'

import Widget from '../Widget'
import HorizontalBarChart from '../components/HorizontalBarChart'
import Subtitle from '../../../components/Subtitle'
import Box from '../../../components/Box'
import withFetch from '../../../infrastructure/withFetch'

const buildQuery = (eventId, startDate, endDate) =>
    `/api/sales/get-customers-by-source/${eventId}?startDate=${startDate}&endDate=${endDate}`

const Chart = withFetch(
    props => buildQuery(props.eventId, props.startDate, props.endDate),
    ({ status, data, retry }) => (
        <Widget status={status} data={data} retry={retry}>
            <HorizontalBarChart
                data={data.map(d => ({
                    x: d.utmMedium
                        ? `${d.utmSource} - ${d.utmMedium}`
                        : d.utmSource,
                    y: d.ticketCount,
                }))}
            />
        </Widget>
    ),
)

const tooltip = (
    <div>
        <p>
            A ticket sold by source is counted each time a Customer engaged with
            a campaign that included source tracking and eventually made a
            purchase. Source tracking in campaigns is normally used to group all
            of your campaigns so you can see the overall success of each entity
            promoting your event.
        </p>
        <p>
            If a Customer clicked on an email newsletter link, clicked on a
            Facebook advert and clicked on a web site banner advert that all had
            campaign (with source) tracking embedded, the number of tickets they
            purchased will be counted 3 times.
        </p>
        <p>
            The purpose is to show sale attribution and all of the entities who
            played a part in each ticket sold, but this does mean that the
            numbers reported here will not match your total sales and may show
            greater numbers than your actual sales.
        </p>
        <p>
            We have the ability to track campaigns from any digital source
            whether it be email, web or social media. To measure the success of
            your campaigns, contact Oztix to organise the links to start
            tracking your campaigns.
        </p>
    </div>
)

const GetBySourceWidget = ({ eventId, startDate, endDate }) => (
    <div>
        <Subtitle
            title="Sources that contributed to tickets sold"
            tooltip={tooltip}
        />
        <Box>
            <Chart eventId={eventId} startDate={startDate} endDate={endDate} />
        </Box>
    </div>
)

export default GetBySourceWidget
